import { render, staticRenderFns } from "./city-picker.vue?vue&type=template&id=37e640bc&scoped=true"
import script from "./city-picker.vue?vue&type=script&lang=js"
export * from "./city-picker.vue?vue&type=script&lang=js"
import style0 from "./city-picker.vue?vue&type=style&index=0&id=37e640bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e640bc",
  null
  
)

export default component.exports